exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#coppa-deny-view .parent-email-blurb {\n  width: 500px; }\n\n#coppa-deny-view .parent-email-input-group {\n  display: flex;\n  align-items: center;\n  text-align: center; }\n  #coppa-deny-view .parent-email-input-group .glyphicon {\n    width: 0;\n    line-height: 40px;\n    font-size: 30px; }\n\n#coppa-deny-view .error {\n  color: red; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/import-glob-loader!./app/styles/modal/create-account-modal/coppa-deny-view.sass
// module id = 821
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91